import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Archer brand type: Archivo (variable: weight + width → Archivo Condensed for captions) and Chakra Petch for labels
import '@fontsource-variable/archivo/standard.css';
import '@fontsource/chakra-petch/400.css';
import '@fontsource/chakra-petch/500.css';
import '@fontsource/chakra-petch/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/ui.css';
import './styles/app.css';
import { App } from './App';
import { applyTheme, usePrefs } from './lib/prefs';

applyTheme(usePrefs.getState().theme);

// Field service worker: the app reopens with no signal (see public/sw.js). Production + HTTPS only.
if (import.meta.env.PROD && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
